import { PageBase } from "./page-base";
import { IconPrepender } from "./icons";
import { SmoothScroller } from "./smooth-scroll";

// This is included as a script tag
declare const mermaid: any;

export class Page extends PageBase {

    private readonly _iconMap:[string, string[]][] = [
        ['action', ['icon-cog']],
        ['link', ['icon-link']],
        ['link-ext', ['icon-link-ext']],
        ['link-ext-alt', ['icon-link-ext-alt', 'grey']],
        ['warning', ['icon-attention']],
        ['important', ['icon-attention-alt']],
        ['tip', ['icon-lightbulb']],
        ['document', ['icon-doc-text']],
        ['note', ['icon-sticky-note']],
        ['no-icon', ['icon-hidden']],
        ['video', ['icon-video']],
        ['plus', ['icon-plus']],
        ['minus', ['icon-minus']]
    ];

    constructor(document: Document) {
        super(document);
        window.onresize = (ev: Event) => { this.updateSideBarWidth(ev) }
    }

    private updateSideBarWidth(ev: Event) {
        const sideBar = document.querySelector('div.sidetoc') as HTMLElement;
        const sideBarWidth = sideBar.offsetWidth;

        const sideFilter = document.querySelector('div.sidefilter') as HTMLElement;
        sideFilter.style.width = sideBarWidth + 'px';

        const article = document.querySelector('div.article') as HTMLElement;
        article.style.marginLeft = Math.min(520, 280 + (sideBarWidth - 240)) + 'px';
    }

    protected onLoad(ev: Event) {
        mermaid.initialize({
            startOnLoad: true
        });

        const iconPrepender = new IconPrepender(this._iconMap);
        iconPrepender.prepend('article');
        
        const searchResultsParent = document.getElementById('search-results')?.parentElement;
        if ( searchResultsParent )
            searchResultsParent.hidden = true;
        
        const tableOfContents = document.getElementById('sidetoc');
        if ( tableOfContents )
            tableOfContents.addEventListener('tocReady', (ev: Event) => { this.updateSideBarWidth(ev) });
        
        SmoothScroller.initialize();
    }
}